import React, {Component} from 'react';
import FormField from './form-field';
import Select from '../select';
export default class SelectInput extends Component {


    render() {
        const {
            label,
            meta,
            showError,
            input,
            required,
            options
        } = this.props;

        return (
            <FormField label={label} meta={meta} showError={showError} required={required}>
                <Select
                    clearable={false}
                    options={options}
                    noResultsText={'Nėra rezultatų'}
                    {...input}
                    onChange={(item)=>{
                        input.onChange(item.value);
                    }}/>
            </FormField>
        );
    }
}





// WEBPACK FOOTER //
// ./src/js/components/form/fields/select-field.jsx